import React from "react";

const DashboardRanking = ({ items = [], onSelect, moneyFormatter, quantityFormatter }) => {
  if (!items.length) {
    return <div className="dashboard-empty">Sin datos para el periodo seleccionado.</div>;
  }

  const max = Math.max(...items.map((item) => Number(item.monto || 0)), 1);

  return (
    <div className="dashboard-ranking">
      {items.map((item, index) => {
        const percent = Math.max(4, (Number(item.monto || 0) / max) * 100);
        return (
          <button
            type="button"
            className="dashboard-ranking__item"
            key={`${item.codigo}-${index}`}
            onClick={() => onSelect?.(item)}
          >
            <div className="dashboard-ranking__rank">{index + 1}</div>
            <div className="dashboard-ranking__content">
              <div className="dashboard-ranking__row">
                <div className="dashboard-ranking__name" title={item.descripcion}>
                  {item.descripcion || item.codigo}
                </div>
                <div className="dashboard-ranking__amount">{moneyFormatter(item.monto)}</div>
              </div>
              <div className="dashboard-ranking__meta">
                <span>{item.codigo}</span>
                <span>{quantityFormatter(item.cantidad)} unidades</span>
              </div>
              <div className="dashboard-ranking__track">
                <span style={{ width: `${percent}%` }} />
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default DashboardRanking;
